import { connect } from 'react-redux'
import App, { StateProps } from './App'
import { ClearErrorMessage } from './actions/ManageError'
import { withRouter } from 'react-router'
import { RootState } from './reducers/root-reducer'
import { IMonitoringService } from "./common/IMonitoringService"
import { IMessageService } from './common/IMessageService';

export interface OwnProps {
  monitoringService: IMonitoringService,
  messageService: IMessageService
}

const mapStateToProps = ({ report }: RootState, {monitoringService, messageService}: OwnProps): StateProps => {
  return {
    errorMessage: report.reportGroupsErrorMessage,
    reportGroupsLoading: report.reportGroupsLoading,
    reportGroups: report.reportGroups,
    monitoringService,
    messageService
  }
}

const mapDispatchToProps = { clearErrorMessage: () => ClearErrorMessage() }

export const AppContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
)
